import { ActionType, createAsyncAction } from 'typesafe-actions';
import { DefaultErrorPayload, FetchAction, SuccessFetchActionPayload } from 'Client/redux/dataFetching/generators';
import { LooksSliderResponse } from 'Client/redux/looksSlider/types';
import { DataFetchingThunkAction } from 'Client/redux/types';
import { log404ErrorAsWarning } from 'Common/apiAdapters/ErrorHandlers';
import { splitAsyncAction } from 'Client/redux/utils';

export const fetchLooksHeaderActions = createAsyncAction(
    '@HEADER_LOOKS/FETCH_START',
    '@HEADER_LOOKS/FETCH_SUCCESS',
    '@HEADER_LOOKS/FETCH_FAILED'
)<FetchAction, SuccessFetchActionPayload<LooksSliderResponse>, DefaultErrorPayload>();

export const LOOKS_HEADER_IDENTIFIER = 'HEADER_LOOKS';

export const fetchHeaderLooksIfNeeded = (identifier = LOOKS_HEADER_IDENTIFIER): DataFetchingThunkAction => async (
    dispatch,
    getState,
    { apiService, logger }
) => {
    if (identifier === getState().header.looksFlyout.identifier) {
        return;
    }

    dispatch(fetchLooksHeaderActions.request({ identifier }));
    try {
        const looks = await apiService.shopApi.getLooksSlider({});
        dispatch(fetchLooksHeaderActions.success({ data: looks, identifier }));
    } catch (err) {
        log404ErrorAsWarning(err, identifier, logger, 'fetchHeaderLooksIfNeeded');
        dispatch(fetchLooksHeaderActions.failure({ error: err, identifier }));
    }
};
export const splitFetchLooksHeaderActions = splitAsyncAction(fetchLooksHeaderActions);
export type LooksHeaderActionsType = ActionType<typeof fetchLooksHeaderActions>;
